/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface DeviceMaker {
  /** Name of the device maker */
  name: string;
  /** Timestamp when the device maker was created */
  createdOn?: string;
  /** UUID of the owner client */
  ownerClientId?: string;
  /** Number of devices associated with the device maker */
  devicesCount: number;
  /** Number of models associated with the device maker */
  modelsCount: number;
}
